import { yupResolver } from '@hookform/resolvers/yup';
import { KeyboardTwoTone } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Widget } from '../../../shared';
import { useRegistrationQrCodeSchema } from '../../validators';
import { ControlledMaskInput } from '../../../shared/components/controlled-mask-input/controlled-mask-input.component';

export const StartRegistrationQrCode: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const form = useForm<{ code: string }>({
        resolver: yupResolver(useRegistrationQrCodeSchema()),
    });

    const onSubmit = useCallback(
        (data: { code: string }) => {
            navigate(`/registration/info?code=${data.code}`);
        },
        [navigate],
    );

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} autoComplete="off">
                <Widget>
                    <Stack spacing={2} alignItems="center" justifyContent="center">
                        <KeyboardTwoTone color="primary" />
                        <Typography variant="h6">{t('typeCode')}</Typography>
                        <ControlledMaskInput name="code" mask="****-****" placeholder="XXXX-XXXX" />
                        <Button type="submit" variant="contained" size="large" fullWidth>
                            {t('startRegistration')}
                        </Button>
                    </Stack>
                </Widget>
            </form>
        </FormProvider>
    );
};
